import { Component, ViewContainerRef } from "@angular/core";
import { EditableTableComponent } from "../../../editable-table/editable-table.component";
import { FormsModule } from "@angular/forms";
import { TableListRequest, ViewItem, Where } from "../../../../models/table-list-request.interface";
import { ActivatedRoute, Router } from "@angular/router";
import { DatePipe, NgClass, NgForOf, NgIf } from "@angular/common";
import { HighlightPipe } from "../../../../pipes/highlight.pipe";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { NoDataFoundComponent } from "../../../no-data-found/no-data-found.component";
import { ResizableModule, ResizeEvent } from "angular-resizable-element";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { TableMenuComponent } from "../../../table-menu/table-menu.component";
import { PaginatedListDataResponse } from "../../../../models/paginated-list-data-response";
import { TooltipDirective } from "../../../../directives/tooltip.directive";
import { OperationService } from "../../../../services/operations.service";
import { LoadingService } from "../../../../services/loading.service";
import { ImportCargoItem } from "../../../../models/cargo-item.interface";
import { JobOrderType, getJobOrderTypesByCycle } from '../../../../constants/operations-contsants';
import { JobOrderStatusTypes } from "../../../../constants/app-constants";
import { TableMenuOption, TableMeta } from "../../../../models/table-meta.interface";
import { TosTableComponent } from "../../../tos-table/tos-table.component";
import jobOrderConfig from "./config/job-order-config.json"
import { ToasterService } from "../../../../services/toaster.service";

@Component({
  selector: "app-job-orders",
  standalone: true,
  imports: [
    EditableTableComponent,
    FormsModule,
    DatePipe,
    HighlightPipe,
    NgForOf,
    NgIf,
    NoDataComponent,
    NoDataFoundComponent,
    ResizableModule,
    SvgIconComponent,
    TableMenuComponent,
    NgClass,
    TooltipDirective,
    TosTableComponent
  ],
  templateUrl: "./job-orders.component.html",
  styleUrl: "./job-orders.component.scss"
})
export class JobOrderComponent {
    protected readonly jobOrderConfig = jobOrderConfig;
    jobOrderTypeOptions = Object.values(JobOrderType).map((type) => ({label: type.value,value: type.key,}));
    jobOrderStatusTypeOptions = Object.values(JobOrderStatusTypes).map((type) => ({label: type.name,value: type.value,}));
    

  searchTerm: any;
  focusSearch!: boolean;
  tableLoaded: boolean = false;
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: []
  };
  tableMeta!: TableMeta;
  sortColumn: string = "modifiedDate";
  totalTablePages: number = 0;
  currentTablePage: any;
  sortDirection: "asc" | "desc" = "desc";
  private rowsPerPage: number = 15;
  private currentPage: number = 0;
  tableListRequest: TableListRequest = {
    selectFields: [
      "id",
      "jobOrderNo",
      "jobOrderType",
      "createdDate",
      "expiryDate",
      "status",
      "startTime",
      "endTime",
      'modifiedDate'
    ],
    orderBy: {
      [this.sortColumn]: this.sortDirection
    },
    includeTotal: true,
    limit: this.rowsPerPage,
    page: this.currentPage
  };

   filterData: Where | null = null;
   rawFilterData: Where | null = null;
   searchFilterData!: Where | null;

  // table menu
  openMenuIndex: number | null = null;
  menuOptions: TableMenuOption[] = [
    { label: 'Edit', value: 'edit', condition: (record) =>  record.status === 'PENDING' },
    { label: 'View', value: 'view' },
    { label: 'Cancel', value: 'cancel', condition: (record) =>  record.status === 'PENDING' },
    { label: 'Mark as Completed', value: 'markAsCompleted', condition: (record) =>  record.status === 'PENDING' },
  ];

  // filter
  filterFields = [
    {
      displayName: 'Job Order Type',
      key: 'jobOrderType',
    }
  ];
  isFilterApplied: boolean = false;

  allTableRecordsSelected: boolean = false;
  selectedItems: any[] = [];
  jobOrderTypeList: any = [];
  dropdownVisible = false;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private operationService: OperationService,
              private loadingService: LoadingService,
              private toasterService: ToasterService,
              private viewContainerRef:ViewContainerRef) {
  }

  ngOnInit() {
    this.tableMeta = jobOrderConfig.tableConfig;
    document.addEventListener('click', () => {
      this.dropdownVisible = false;
    });
    this.filterFieldDropdown();
    //this.fetchAllRecords();
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.dropdownVisible = !this.dropdownVisible;
  }

  selectOption(option: any) {
    this.dropdownVisible = false;
    this.router.navigate(['create-new'], { relativeTo: this.route, state: { jobOrderType: option.key, processCycle: option.cycle } });
  }

  fetchAllRecords() {
    this.loadingService.show('inline');
    this.operationService.getJobOrdersList(this.tableListRequest).subscribe({
      next: (res: any) => {
        console.log("Response received:", res.data.records);
        this.tableListData = res.data;
        this.tableLoaded = true;
        this.loadingService.hide()
      },
      error: (error: Error) => {
        console.error("Error occurred:", error);
        this.tableLoaded = false;
        this.loadingService.hide()
      }
    });
  }

  handleViewChange(viewOption: ViewItem) {
    this.jobOrderTypeList = getJobOrderTypesByCycle(viewOption.id);
  }





  addNewRecord() {
    this.router.navigate(['add-new'], { relativeTo: this.route });
  }





  onResizeEnd(event: ResizeEvent, column: string) {
    if (event.edges.right) {
      const columnHeader = document.querySelector(`th.${column}_th`) as HTMLElement;
      const columnCells = document.querySelectorAll(`td.${column}_td`);
      const newWidth = `${event.rectangle.width}px`;

      if (columnHeader) {
        columnHeader.style.width = newWidth;
      }

      columnCells.forEach(cell => {
        const cellHtml = cell as HTMLElement;
        cellHtml.style.width = newWidth;
      });
    }
  }



  isSelected(item: ImportCargoItem) {
    if (this.allTableRecordsSelected) {
      return true;
    } else {
      const recordIdx = this.selectedItems.findIndex((x) => x.id === item.id);
      if (recordIdx !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  toggleSelection(item: ImportCargoItem) {
    if (!this.isSelected(item)) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
    }
  }

  handleMenuSelection(event: any) {
    const {record, actionName} = event
    const recordId = record.id;
    if (actionName === 'edit') {
      this.router.navigate([`edit/${recordId}`], {
        relativeTo: this.route,
        state: { jobOrderType: record.jobOrderType }
      });
    } else if (actionName === 'view') {
      this.router.navigate([`view/${recordId}`], {
        relativeTo: this.route,
        state: { jobOrderType: record.jobOrderType }
      });
    }
    else if (actionName === 'cancel') {
      this.cancelJobOrder(recordId);
    } else if (actionName === 'markAsCompleted') {
      this.markAsCompleted(recordId);
    }
  }


  calculateTotalPages() {
    if (this.tableListRequest.where) {
      this.totalTablePages = Math.ceil(
        this.tableListData.totalCount / this.rowsPerPage
      );
    }
  }



  cancelJobOrder(jobOrderId: string) {
    this.loadingService.show();
    this.operationService.cancelJobOrder(jobOrderId).subscribe({
      next: (res: any) => {
        console.log("Response received:", res.data.records);
        this.toasterService.success("Job Order has been cancelled");
        this.fetchAllRecords();
        this.loadingService.hide();
      },
      error: (error) => {
        console.error("Error occurred:", error);
        this.toasterService.error(error.error.errorDesc);
        this.loadingService.hide()
      }
    });
  }

  markAsCompleted(jobOrderId: string) {
    this.loadingService.show();
    this.operationService.markAsCompleted(jobOrderId).subscribe({
      next: (res: any) => {
        console.log("Response received:", res.data.records);
        this.toasterService.success("Job Order has been marked as completed");
        this.fetchAllRecords();
        this.loadingService.hide();
      },
      error: (error) => {
        console.error("Error occurred:", error);
        this.toasterService.error(error.error.errorDesc);
        this.loadingService.hide()
      }
    });
  }

    filterFieldDropdown() {
    const fieldInfoList: any[] = this.jobOrderConfig.filterConfig.filterFields;
    const jobOrdereTypeFilterField = fieldInfoList.find((field: any) => field.name === 'JOB_ORDER_TYPE_EQUALS');
    if (jobOrdereTypeFilterField) {
      jobOrdereTypeFilterField.options = this.jobOrderTypeOptions;
    }
    
    const jobOrderStatusTypeFilterField = fieldInfoList.find((field: any) => field.name === 'JOB_ORDER_STATUS_EQUALS');
    if (jobOrderStatusTypeFilterField) {
      jobOrderStatusTypeFilterField.options = this.jobOrderStatusTypeOptions;
    }
   }
}
